import React from 'react';
import { CheckCircle, XCircle, MinusCircle } from 'lucide-react';

const MarkingSchemeDisplay = ({ markingScheme, questionType }) => {
  if (!markingScheme) {
    return null;
  }

  const getQuestionTypeLabel = (type) => {
    switch (type) {
      case 'multiple-choice':
        return 'Multiple Choice';
      case 'integer':
        return 'Integer';
      case 'floating-point':
        return 'Floating Point';
      case 'subjective':
        return 'Subjective';
      case 'matrix-match':
        return 'Matrix Match';
      case 'assertion-reason':
        return 'Assertion-Reason';
      default:
        return type;
    }
  };

  return (
    <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
      <h4 className="text-sm font-semibold text-blue-800 mb-2">
        Marking Scheme - {getQuestionTypeLabel(questionType)}
      </h4>
      <div className="flex items-center space-x-4 text-sm">
        <div className="flex items-center space-x-1">
          <CheckCircle size={16} className="text-green-600" />
          <span className="text-green-700 font-medium">+{markingScheme.correct}</span>
          <span className="text-gray-600">Correct</span>
        </div>
        
        {markingScheme.incorrect !== 0 && (
          <div className="flex items-center space-x-1">
            <XCircle size={16} className="text-red-600" />
            <span className="text-red-700 font-medium">{markingScheme.incorrect}</span>
            <span className="text-gray-600">Incorrect</span>
          </div>
        )}
        
        {markingScheme.partial > 0 && (
          <div className="flex items-center space-x-1">
            <MinusCircle size={16} className="text-yellow-600" />
            <span className="text-yellow-700 font-medium">+{markingScheme.partial}</span>
            <span className="text-gray-600">Partial</span>
          </div>
        )}
      </div>
      
      {/* Additional info for specific question types */}
      {questionType === 'multiple-choice' && (
        <div className="mt-2 text-xs text-gray-600">
          {markingScheme.partial > 0 ? 
            "Partial credit available for multi-select questions" : 
            "Single correct answer required"
          }
        </div>
      )}
      
      {questionType === 'subjective' && (
        <div className="mt-2 text-xs text-gray-600">
          "Marks awarded based on answer quality and completeness"
        </div>
      )}
      
      {questionType === 'matrix-match' && (
        <div className="mt-2 text-xs text-gray-600">
          "Partial credit for some correct matches"
        </div>
      )}
    </div>
  );
};

export default MarkingSchemeDisplay;
